// components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledPaperBox = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(2, 3)
}));
